import '../src/components/base_components.js';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'clipboard';

import api from '@/src/api';
import CopyToClipboard from '@/src/components/copy_to_clipboard.vue';
import EditableItemName from '@/src/components/editable_item_name.vue';
import EnjoyTrialModal from '@/src/components/enjoy_trial_modal.vue';
import GetCloudappButton from '@/src/components/get_cloudapp_button.vue';
import InviteCollaboratorsModal from '@/src/components/invite_collaborators_modal.vue';
import LoginModal from '@/src/components/login_modal.vue';
import Logo from '@/src/components/logo.vue';
import Modal from '@/src/components/modal.vue';
import NavMenu from '@/src/components/nav_menu.vue';
import NotificationPanel from '@/src/components/notification_panel.vue';
import Popover from '@/src/components/popover.vue';
import PrizeStepsModal from '@/src/components/prize_steps_modal.vue';
import ProBadge from '@/src/components/pro_badge.vue';
import Avatar from '@/src/components/shared/avatar.vue';
import HardLimitDropsCounter from '@/src/components/shared/hard_limit_drops_counter.vue';
import ItemFavorite from '@/src/components/shared/item_favorite.vue';
import SidebarMenu from '@/src/components/shared/sidebar_menu.vue';
import UpgradeButton from '@/src/components/shared/upgrade_button.vue';
import SignupModal from '@/src/components/signup_modal.vue';
import UserName from '@/src/components/user_name.vue';
import ViewOnlyModal from '@/src/components/view_only_modal.vue';
import CollectionsModal from '@/src/components/viewer/collections_modal.vue';
import Comments from '@/src/components/viewer/comments.vue';
import CtaButton from '@/src/components/viewer/cta/cta_button.vue';
import CtaMenu from '@/src/components/viewer/cta/cta_menu.vue';
import DownloadModal from '@/src/components/viewer/download_modal.vue';
import DropperItem from '@/src/components/viewer/dropper_item.vue';
import ItemActions from '@/src/components/viewer/item_actions.vue';
import ItemAnalytics from '@/src/components/viewer/item_analytics.vue';
import ItemCollection from '@/src/components/viewer/item_collection.vue';
import LimitReachedModal from '@/src/components/viewer/limit_reached_modal.vue';
import ProLink from '@/src/components/viewer/pro_link.vue';
import SecurityModal from '@/src/components/viewer/security_modal.vue';
import ShareEmail from '@/src/components/viewer/share/share_email.vue';
import store from '@/src/components/viewer/store.js';
import TemplateModal from '@/src/components/viewer/template_modal.vue';
import TemplateSidebar from '@/src/components/viewer/template_sidebar.vue';
import UpgradeModal from '@/src/components/viewer/upgrade_modal.vue';
import ViewerSidebarPanels from '@/src/components/viewer_sidebar_panels.vue';
import WelcomeBanner from '@/src/components/viewer/welcome_banner.vue';
import EventBus from '@/src/event_bus';
import FlashToast from '@/src/mixins/flashToast';
import { openModal } from '@/src/open_modal.js';
import ItemDescription from '@cmp/viewer/item_description.vue';
import ItemFooter from '@cmp/viewer/item_footer.vue';
import LoadingSpinner from '@cmp/viewer/loading_spinner.vue';
import { BootstrapVue } from 'bootstrap-vue';
import _ from 'lodash';
import Vue from 'vue';
import VueClosable from 'vue-closable';
import VueCookies from 'vue-cookies';
import linkify from 'vue-linkify';
import VueRouter from 'vue-router';
import { mapState } from 'vuex';

import SoftLimitReachedModal from '../src/components/soft_limit_reached_modal.vue';
import featureKey from '../src/feature_key.macro';

// Used in _comments.html.erb ("Overview" tab)
// TODO: Make Overview tab its own component
// TODO: Make Comments tab its own component

Vue.use(BootstrapVue)

Vue.use(VueClosable);

Vue.mixin(FlashToast);

Vue.use(VueCookies)

// Expose for embedding.js (loaded via sprockets application.js)
Vue.directive("linkified", linkify);

require("@/stylesheets/overrides.scss");
require("@/stylesheets/viewer.scss"); // Until we make this file into a SFC
require("@/stylesheets/confirmation_modal.scss"); // This generic confirmation modal is being rendered using $bvModal for easier configuration, need to override styles like this.

const jsRoutes = require("routes.js.erb");

// TODO: Fix indentation below. Should be done in a whitespace-only PR, so it doesn't have to be QA'd.
// to avoid auto zoom in iphone on input focus
const addMaximumScaleToMetaViewport = () => {
  const el = document.querySelector("meta[name=viewport]");

  if (el !== null) {
    let content = el.getAttribute("content");
    let re = /maximum\-scale=[0-9\.]+/g;

    if (re.test(content)) {
      content = content.replace(re, "maximum-scale=1.0");
    } else {
      content = [content, "maximum-scale=1.0"].join(", ");
    }

    el.setAttribute("content", content);
  }
};

const disableIosTextFieldZoom = addMaximumScaleToMetaViewport;

// https://stackoverflow.com/questions/9038625/detect-if-device-is-ios/9039885#9039885
const checkIsIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

if (checkIsIOS()) {
  disableIosTextFieldZoom();
}
let { last_call_to_action } = JSON.parse(gon.viewer_data);

Vue.mixin({
  data() {
    return {
      gon: this.$store.state.gon
    }
  },
});
Vue.use(VueRouter);
Vue.use(require("vue-pusher"), {
  api_key: gon.pusher.api_key,
  options: {
    encrypted: true,
    authEndpoint: gon.pusher.auth_url,
  },
});

const routes = [
  {
    path: "/:slug",
    name: "viewer",
    beforeEnter: (_to, _from, next) => {
      $("body").removeClass("annotate");
      next();
    },
  },
  {
    path: "/:slug/annotate",
    component: () => import("@/src/components/annotate.vue"),
    name: "annotate",
    beforeEnter: (to, _from, next) => {
      // need this to hide HS beacon in annotate
      $("body").addClass("annotate");
      // disable annotate for 'mobile' while we get proper designs and implement it.
      const annotateInMobile = window.innerWidth < 768;
      const inCustomDomain = [window.location.hostname, window.location.host].indexOf(gon.baseWebDomain) < 0;
      if (annotateInMobile || inCustomDomain) next({ name: "viewer", params: { slug: to.params.slug } });
      else next();
    },
  },
  {
    path: "/:slug/annotate-video",
    component: () => import("@/src/components/annotate_video.vue"),
    name: "annotate",
    beforeEnter: (to, _from, next) => {
      // need this to hide HS beacon in annotate
      $("body").addClass("annotate");
      // disable annotate for 'mobile' while we get proper designs and implement it.
      const annotateInMobile = window.innerWidth < 768;
      const inCustomDomain = [window.location.hostname, window.location.host].indexOf(gon.baseWebDomain) < 0;
      if (annotateInMobile || inCustomDomain) next({ name: "viewer", params: { slug: to.params.slug } });
      else next();
    },
  },
  {
    path: "/:slug/analytics",
    name: "analytics",
  },
];

const router = new VueRouter({ mode: "history", routes });

let vm = new Vue({
  components: {
    DropperItem,
    Annotate: () => import("@/src/components/annotate.vue"),
    AnnotateOld: () => import("@/src/components/annotate_old.vue"),
    UpgradeTeamModal: () => import("@cmp/shared/upgrade_team_modal.vue"),
    CampaignModal: () => import("@cmp/shared/campaign_modal.vue"),
    CopyToClipboard,
    CtaButton,
    Avatar,
    CtaMenu,
    ViewerSidebarPanels,
    ItemAnalytics,
    LimitReachedModal,
    Comments,
    GetCloudappButton,
    NavMenu,
    UserName,
    Popover,
    NotificationPanel,
    SidebarMenu,
    ProBadge,
    ProLink,
    UpgradeModal,
    Modal,
    InviteCollaboratorsModal,
    EnjoyTrialModal,
    ViewOnlyModal,
    LoginModal,
    SignupModal,
    PrizeStepsModal,
    TemplateModal,
    TemplateSidebar,
    SecurityModal,
    CollectionsModal,
    HardLimitDropsCounter,
    Logo,
    ShareEmail,
    ItemActions,
    ItemCollection,
    ItemFavorite,
    LoadingSpinner,
    ItemDescription,
    ItemFooter,
    EditableItemName,
    UpgradeButton,
    DownloadModal,
    SoftLimitReachedModal,
    WelcomeBanner,
  },
  el: "#viewer-vue",
  store: store,
  router: router,
  mixins: [FlashToast],
  data: function() {
    return {
      userLoggedIn: !!gon.currentUser,
      currentUserCanAdminOrg: gon.currentUserCanAdminOrg,
      customDomainOrigin: gon.customDomainOrigin,
      routes: jsRoutes,
      hoverLogo: false,
      hoverComment: false,
      hoverName: false,
      showCollectionName: false,
      clipboard: {
        hover: false,
        copied: false,
      },
      edit: false,
      player: null,
      zoomed: false,
      event: null,
      preview: {
        cta: {},
        item: {},
      },
      cta: {
        menuOpen: false,
        timedDisplayTypes: ["image", "text", "pdf", "other", "file"],
      },
      template: {
        menuOpen: false,
      },
      last_call_to_action: last_call_to_action,
      use_last_settings: false,
      shareMessage: {
        visible: true,
        timer: null,
      },
      videoEnded: false,
      loginEmail: "",
      // Vue complains this props are referenced in views but not here,
      // not sure where are this used but fixes the warning.
      viewer: null,
      annotate: null,
      link: null,
      uploadingAnnotation: false,
      itemOrganization: gon.itemOrganization,
      selectedExpirationProxy: null,
      licenseRequested: gon.license_requested,
      mobile: false,
    };
  },
  created: function() {
    const vm = this;

    // fetching item via the api even though it's already provided via gon in order to allow included relational data
    vm.$store.dispatch("getItem", this.item.id);
    const cta_id = vm.item.relationships?.call_to_action?.data?.id;

    if (cta_id) {
      vm.$store.dispatch("getCallToAction", { id: cta_id });
    }
    if (gon.currentOrganizationId) {
      vm.$store.dispatch("getCurrentOrganization", gon.currentOrganizationId);
    }
    if (vm.userLoggedIn) {
      vm.$store.dispatch("getUser");
    }

    // This depends on `item` being set. Right now it's passed in via gon; if it's ever pulled async
    // this needs to be run after the values are populated.
    vm.trackView();

    vm.$store.dispatch("getFeatures");

    this.resizeHandler();
    addEventListener("resize", this.resizeHandler);
  },
  beforeDestroy: function() {
    removeEventListener("resize", this.resizeHandler);
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      item: (state) => state.item,
      currentOrganization: (state) => state.currentOrganization,
      selectedMobileOption: (state) => state.selectedMobileOption,
      viewOnlyUser: (state) => state.itemOrganization.attributes.current_user_view_only,
      features: (state) => state.features,
    }),
    call_to_action: function() {
      // if there's no CTA and menu is closed, no need to display anything.
      if (!this.$store.state.call_to_action.id && _.isEmpty(this.preview.cta) && !this.cta.menuOpen)
        return { attributes: {} };

      return {
        ...this.$store.state.call_to_action,
        attributes: { ...this.$store.state.call_to_action.attributes, ...this.preview.cta },
      };
    },
    displayCta: function() {
      if (this.call_to_action.display_action === false) return false;
      if (this.cta.menuOpen || this.template.menuOpen) return true;

      if (this.call_to_action.attributes.appearance === "cta-button-hover") {
        if (this.item.attributes.item_type === "video") {
          return this.videoEnded;
        }
      }

      if (!this.call_to_action.id) return false; // Unsaved

      return true;
    },
    isOwner: function() {
      return this.item.relationships.user.data.id == gon.currentUser;
    },
    showSimplifiedInterface: function () {
      return this.$store.getters.showSimplifiedInterface;
    },
    selectedExpiration: {
      get: function() {
        return this.selectedExpirationProxy === null
          ? this.item.attributes.security?.expires || ""
          : this.selectedExpirationProxy;
      },
      set: function(value) {
        this.selectedExpirationProxy = value;
      },
    },
    name: function() {
      return this.item.attributes.name;
    },
    type: function() {
      return this.item.attributes.item_type;
    },
    templateSidebarOpen: function() {
      return this.template.menuOpen;
    },
    templateSidebarOpen: function() {
      return this.template.menuOpen;
    },
    ctaSidebarOpen: function() {
      return this.cta.menuOpen;
    },
    allowWebAnnotation: function() {
      if (!this.isOwner) {
        return false;
      }
      if (this.item.attributes.item_type !== "image") {
        return false;
      }
      if (this.item.attributes.file_ext == ".gif") {
        return false;
      }
      return true;
    },
    webAnnotateRoute: function() {
      if (this.viewOnlyUser) {
        return { path: this.$route.path, hash: "view-only" };
      } else {
        return { name: "annotate", params: { slug: this.item.id } };
      }
    },
    showUpgradeTeamModal: function() {
      return this.features?.[featureKey("top_user_team_prompt")];
    },
    currentCollection: function() {
      if (!this.showCollectionName) return {};
      return _.find(this.$store.state.collections, { id: this.$route.query?.collection_id });
    },
  },
  methods: {
    trackView: async function() {
      const vm = this;
      const host = gon.baseWebDomain || window.location.host + (window.location.port ? `:${window.location.port}` : "");
      let trackingAllowed = true;

      // When 'sv' (skip view) is present, do an XHR request to set a cookie so we can skip quietly next time.
      if (vm.$route.query?.sv) {
        api.post(vm.routes.disallow_tracking_url({ host: host }));
        trackingAllowed = false;
      } else {
        await api.get(vm.routes.show_tracking_url({ host: host })).then((result) => {
          if (result.data.tracking_allowed === false) {
            trackingAllowed = false;
          }
        });
      }

      if (trackingAllowed && gon.customDomainOrigin) {
        api.post(vm.routes.track_view_url({ host: host, item: vm.item.id }));
      } else if (!trackingAllowed && !gon.customDomainOrigin) {
        vm.$cookies.set("dont_track_views", "1", "10y");
      }
    },
    setNavbarMode() {
      const vm = this;
      let collectionPageID = vm.$route.query?.collection_id,
        itemCollections = vm.item.relationships?.collections?.data;

      for (const [key, value] of Object.entries(itemCollections)) {
        if (value.id === collectionPageID) {
          vm.$store.dispatch("getAllCollections").then(function() {
            vm.showCollectionName = true;
          });
          return;
        }
      }
    },
    clearPreview() {
      this.preview = {
        cta: {},
        item: {},
      };
    },
    commitPreview() {
      this.$store.commit("updateItem", this.preview.item);
      this.$store.commit("setCallToAction", this.call_to_action);
    },
    updateCtaFromTemplate: function(values) {
      this.$set(this.preview.cta, "display_action", values.buttonEnabled);
      this.$set(this.preview.cta, "text", values.buttonText);
      this.$set(this.preview.cta, "link", values.buttonLink);
    },
    updateTitleFromTemplate: function(value) {
      this.$set(this.preview.item, "title", value);
    },
    updateDescriptionFromTemplate: function(value) {
      this.$set(this.preview.item, "description", value);
    },
    openUpgradeModal: function() {
      $("#upgrade-modal").modal("show"); // See comments in upgrade_modal.vue
    },
    updateUseLastSettings: function(data) {
      this["use_last_settings"] = data;
      if (data) {
        this.$store.commit("setCallToAction", this.last_call_to_action);
      }
    },
    toggleEdit: function() {
      // Only enter edit mode when we are in desktop.
      // Display for the editNameButton is none in mobile
      let mobile = window.matchMedia("(max-width: 991px)").matches;
      this.edit = mobile ? this.edit : !this.edit;
      if (this.edit) {
        setTimeout(function() {
          $("#rename-input-drop").focus();
        }, 10);
      }
    },
    renameItem: function() {
      let $form = $("#renameDrop")[0];
      Rails.fire($form, "submit");
    },
    setCtaTimer: function() {
      if (this.call_to_action.attributes.display_action) {
        if (~this.cta.timedDisplayTypes.indexOf(this.type)) {
          setTimeout(
            function() {
              this.cta.contentDone = true;
            }.bind(this),
            3000
          );
        }
      }
    },
    paused: function() {
      // return whether videojs or the video element is paused
      return (typeof this.player.paused === "function" && this.player.paused()) || this.$refs.videoPlayer.paused;
    },
    sendTrackEvent: function(event, params) {
      const http = new XMLHttpRequest();
      const url = "tracking";

      http.open("POST", url, true);

      http.setRequestHeader("Content-type", "application/json");

      http.send(JSON.stringify({ event, ...params }));
    },
    updateRecentComments: function() {
      const timestamps = document.querySelectorAll(".comment > .comment-header > .timestamp");
      const lastVisit = JSON.parse(localStorage.getItem("last_visited")) || {};

      // This just adds a blue bullet to the author name if the comment is new since last visit.
      for (const timestamp of timestamps) {
        let created = new Date(timestamp.getAttribute("data-created-at") * 1000);
        if (created > (lastVisit[this.item.id] || 0)) {
          const author = timestamp.parentElement.querySelector(".author");
          author.classList.add("recent");
        }
      }

      // If we have too many values, purge old "last visited" values. This is too keep things
      // speedy, and to not unnecessarily bloat the browser. Anything older than 14 days is
      // purged once we hit >100 entries.
      //
      // If they visit many hundreds of items within 2 weeks the localStorage data will grow.
      if (Object.keys(lastVisit).length > 100) {
        for (const [item_id, visit_time] of Object.entries(lastVisit)) {
          if (new Date(visit_time) < new Date() - 86400 * 14 * 1000) {
            delete lastVisit[item_id];
          }
        }
      }
      lastVisit[this.item.id] = new Date();
      localStorage.setItem("last_visited", JSON.stringify(lastVisit));
    },
    setupEventListeners: function() {
      EventBus.$on("annotate:upload", () => (this.uploadingAnnotation = true));
    },
    updateNotification: function(notification) {
      EventBus.$emit("notification:updated");
    },
    normalizeAndRefresh: function(response) {
      const version = response.meta?.version || 4;
      if (window.manualReload) return;

      if (version == 5) {
        this.determineReload(response.data.item);
      } else {
        // if fired from a v4 client, fetch v5 item to commit to state
        this.$store.dispatch("getItem", this.$route.params.slug).then(
          function(response) {
            this.determineReload(response);
          }.bind(this)
        );
      }
    },
    determineReload: function(newItem) {
      // This should reload only the viewer component, not refresh the whole page.
      // We need more Vue before that happens.
      // skips items that were just annotated, only happens in owner window
      if (vm.uploadingAnnotation) return;

      // Skip items that are not this item
      if (newItem.id != vm.item.id) return;

      if (vm.item.attributes.item_type == "video" && vm.item.attributes.action_type != "gt") {
        // gt actioned type items, are 'videos' that later become gifs, don't treat them as videos
        // Reload videos that aren't HLS when they complete
        // v5 api attribute for m3u8 is instant_video
        if (vm.item.attributes.m3u8 || vm.item.attributes.instant_video) return;

        if (vm.item.attributes.status == "incomplete" && newItem.attributes.status == "completed") {
          this.$store.commit("setItem", newItem);

          document.dispatchEvent(this.event);
          return;
        }

        if ($(".modal.show").length > 0) return; // Bail if there's a modal dialog open
        if (videojs("#video-item").paused()) return this.$store.commit("setItem", newItem);
      } else {
        // Any other item type, just reload on any update / change.
        this.$store.commit("setItem", newItem);
        document.dispatchEvent(this.event);
      }
    },
    pusherSubscribe: function() {
      // There were previous references to this channel. I don't know if it actually
      // exists (might be in use by clients, but it's not in use by dropper or documented)
      const itemChannelV5 = this.$pusher.subscribe(`item_${this.item.id}_v5`);
      const itemChannelV4 = this.$pusher.subscribe(`item_${this.item.id}`);

      itemChannelV5.bind("item_update", this.normalizeAndRefresh);
      itemChannelV4.bind("item_update", this.normalizeAndRefresh);

      if (!gon.pusher.channel) return;

      const userChannel = this.$pusher.subscribe(gon.pusher.channel);

      userChannel.bind("item_delete", this.normalizeAndRefresh);
      userChannel.bind("notification", this.updateNotification);

      // GROW-420
      // TODO: Duplicate in dashboard.js (GROW-502)
      userChannel.bind("reload_after_achievement_update", () => {
        const updateGon = (data) => {
          this.$store.commit('setGonUserAchievements', data);
        }

        gon.watch('user_onboarding_achievements', updateGon);
      });
    },
    checkCompletion: function(x) {
      // Check if the item completed before we were
      // able to connect to the pusher channel.
      let self = this;
      api.get(`${gon.baseWebUrl}${this.routes.api_v5_item_path(this.item.id)}`).then((response) => {
        if (response?.data?.data?.item?.attributes?.status === "completed") {
          this.$store.commit("setItem", response.data.data.item);
          document.dispatchEvent(self.event);
        } else {
          // reschedule
          self.scheduleCheck(x + 1);
        }
      });
    },
    scheduleCheck: function(x) {
      const MAX_RETRIES = 5;
      if (x >= MAX_RETRIES) return;
      let wait = Math.pow(x, 2) * 1000;
      if (this.item.attributes.uploading) {
        setTimeout(this.checkCompletion.bind(null, x), wait);
      }
    },
    goToOrgSettings: function(event, url) {
      event.preventDefault();
      window.location.href = url;
    },
    handleKeyDown: function(e) {
      const { altKey, ctrlKey, key, metaKey, shiftKey } = e;
      const keyUpper = key.toUpperCase();

      const sidebarMenuOpen = this.template.menuOpen || this.cta.menuOpen;
      if (altKey || shiftKey) {
        return;
      }

      if ((ctrlKey || metaKey) && keyUpper === "A" && this.allowWebAnnotation && !sidebarMenuOpen) {
        e.preventDefault();
        this.$router.push(this.webAnnotateRoute);
      }
    },
    resizeHandler() {
      this.mobile = window.matchMedia("(max-width: 768px)").matches;
    },
  },
  watch: {
    currentOrganization: function(value) {
      if (value?.id) {
        openModal();
      }
    },
  },
  props: {},
  mounted() {
    this.event = new Event("update_embed");
    this.setupEventListeners();
    this.updateRecentComments();
    this.setCtaTimer();
    this.scheduleCheck(0);
    this.pusherSubscribe();
    this.setNavbarMode();

    this.shareMessage.timer = setTimeout(() => {
      this.shareMessage.visible = false;
    }, 2000);

    $("#image-item").on(
      "load",
      function() {
        let container_height = $("#viewer-item")[0].clientHeight;
        let container_width = $("#viewer-item")[0].clientWidth;
        let h = $("#image-item")[0].clientHeight;
        let w = $("#image-item")[0].clientWidth;
        if (h / w < container_height / container_width) {
          this.coverHeight = true;
        } else {
          this.coverHeight = false;
        }
      }.bind(this)
    );

    document.addEventListener("keydown", this.handleKeyDown);
  },
  unmounted() {
    document.removeEventListener("keydown", this.handleKeyDown);
  },
  beforeDestroy() {
    if (this.player) {
      // hlsjs destroy
      if (typeof this.player.destroy === "function") {
        this.player.destroy();
      }
      // yvideojs dispose
      if (typeof this.player.dispose === "function") {
        this.player.dispose();
      }
    }

    if (this.shareMessage.timer) {
      clearTimeout(this.shareMessage.timer);
    }
  },
});
